import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
//import axios from "axios";
import api from "../../api/axios";



const LoginForm = () => {
  const navigate = useNavigate();

  // Generate random 16-digit number
  const generateDeviceToken = () => {
    return Math.floor(10000000 + Math.random() * 90000000).toString();
  };

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    device_token: generateDeviceToken(), // You can get this from FCM or other service
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await api.post(
        "/login",
        formData
      );

      if (response.data.success) {
        localStorage.setItem("accessToken", response.data.data.token);
        localStorage.setItem("user", JSON.stringify(response.data.data.user));
        navigate("/select-context");
        //navigate("/dashboard");
      } else {
        setError("Login failed. Please try again.");
      }
    } catch (err) {
      if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="p-2 mt-5" onSubmit={handleSubmit}>
      {error && <div className="alert alert-danger">{error}</div>}

      <div className="input-group auth-form-group-custom mb-3">
        <span className="input-group-text bg-primary bg-opacity-10 fs-16">
          <i className="mdi mdi-account-outline auti-custom-input-icon"></i>
        </span>
        <input
          type="email"
          className="form-control"
          placeholder="Enter email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>

      <div className="input-group auth-form-group-custom mb-3">
        <span className="input-group-text bg-primary bg-opacity-10 fs-16">
          <i className="mdi mdi-lock-outline auti-custom-input-icon"></i>
        </span>
        <input
          type="password"
          className="form-control"
          placeholder="Enter password"
          name="password"
          value={formData.password}
          onChange={handleChange}
          required
        />
      </div>

      <div className="mb-sm-5 d-flex justify-content-between">
        <div className="form-check">
          <input type="checkbox" className="form-check-input" id="remember" />
          <label className="form-check-label" htmlFor="remember">
            Remember me
          </label>
        </div>
        <a href="#" className="text-muted">
          <i className="mdi mdi-lock me-1"></i> Forgot your password?
        </a>
      </div>

      <div className="pt-3 text-center">
        <button
          type="submit"
          className="btn btn-primary w-100 waves-effect waves-light"
          disabled={loading}
        >
          {loading ? "Logging in..." : "Log In"}
        </button>
      </div>

      {/* <div className="mt-3 text-center">
        <p className="mb-0">
          Don't have an account?{" "}
          <a href="#" className="fw-medium text-primary">
            Register
          </a>
        </p>
      </div> */}
    </form>
  );
};

export default LoginForm;
